export const calendarConfig = {
  sameDay: '[hoje]',
  nextDay: '[amanhã]',
  nextWeek: 'dddd',
  lastDay: '[ontem]',
  lastWeek: function () {
    if (this.isoWeekday() !== 6 && this.isoWeekday() !== 7) {
      return `[a última] dddd`;
    } else {
      return `[o último] dddd`;
    }
  },
  sameElse: 'DD [de] MMMM [de] YYYY',
};
